window.mobileortablet = $('body').data('mobileortablet');

function handleFirstTab(e) {
    if (e.keyCode === 9) { // the "I am a keyboard user" key
        document.body.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', handleFirstTab);
    }
}

window.addEventListener('keydown', handleFirstTab);

window.scrollToObject = function(obj) {
    $('html, body').animate({
        scrollTop: obj.offset().top - $headerheight
    }, 750);
};

window.scrollToId = function(id) {
    $('html, body').animate({
        scrollTop: $("#" + id).offset().top - $headerheight
    }, 750);
};
